import CRUDgeneric from 'utils/CRUDgeneric';

export const URIclavePresupuestal = '/configuraciones/clave-presupuestal/'; // Tabla
export const URIclavePresupuestalIngresos = '/configuraciones/clave-presupuestal-ingresos/'; // Form
export const URIclavePresupuestalIngresosConceptosDeIngreso = '/configuraciones/clave-presupuestal-ingresos-conceptos-de-ingreso/'; // miniTabla

export const CRUDclavePresupuestal = CRUDgeneric(URIclavePresupuestal);
export const CRUDclavePresupuestalIngresos = CRUDgeneric(URIclavePresupuestalIngresos);
export const CRUDclavePresupuestalIngresosConceptosDeIngreso = CRUDgeneric(
  URIclavePresupuestalIngresosConceptosDeIngreso,
);

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelClavesPresupuestalesDeIngreso = {
  nameModel: 'Claves Presupuestales',
  nameModelSingular: 'la clave presupuestal',
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelClavesPresupuestalesDeIngresoConceptosDeIngreso = {
  nameModel: 'Concepto de Ingreso',
  nameModelSingular: 'el Concepto de Ingreso',
};

export const normalizeDataAreas = (_areasFetchArray) => {
  const mainMap = new Map();
  _areasFetchArray.forEach((item) => {
    mainMap.set(item.id, { ...item, children: [] });
  });
  const result = [];
  _areasFetchArray.forEach((item) => {
    if (item.directorio_area_padre) {
      const parent = mainMap.get(item.directorio_area_padre);
      if (parent) {
        parent.children.push(mainMap.get(item.id));
      }
    } else {
      result.push(mainMap.get(item.id));
    }
  });
  const sortByClave = (nodes) => {
    nodes.sort((a, b) => a.clave.localeCompare(b.clave));
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        sortByClave(node.children);
      }
    });
  };
  sortByClave(result);
  return result;
};

export const formatTreeSelectData = (nodes) => nodes.map((node) => ({
  ...node,
  title: `${node.clave} - ${node.nombre.trim()}`,
  value: node.id,
  children: node.children ? formatTreeSelectData(node.children) : [],
}));

export const normalizeCuentasContables = (_data) => {
  if (_data) {
    const newData = [];
    let elementosPadre = [];
    _data.forEach((item) => {
      const clone = { ...item };
      const title = `${clone.clave_visible || clone.clave} - ${clone.nombre}`;
      clone.title = title;
      clone.value = clone.id;
      clone.key = clone.id;

      newData[clone.id] = clone;

      if (clone.cuenta_padre) {
        const padre = newData[clone.cuenta_padre];
        if (padre) {
          padre.children = padre.children || [];
          padre.children = [...padre.children, clone];
        } else {
          elementosPadre = [...elementosPadre, clone];
        }
      } else {
        elementosPadre = [...elementosPadre, clone];
      }
    });
    return elementosPadre;
  }
  return [];
};
export const findInTree = (tree, id) => {
  const search = (nodes) => {
    if (!nodes) return null;
    return nodes.reduce((found, node) => {
      if (found) return found;
      if (node.id === id) return node;
      if (node.children) return search(node.children);
      return null;
    }, null);
  };
  return search(tree);
};

export const filterTreeData = (
  treeData = [],
  searchValue,
  fields = ['title'],
) => {
  if (!searchValue) return treeData;

  const lower = searchValue.toLowerCase();

  const matches = (node) => fields.some((field) => node[field]?.toLowerCase().includes(lower));

  const filterRecursive = (nodes) => nodes
    .map((node) => {
      const children = node.children
        ? filterRecursive(node.children)
        : [];

      if (matches(node) || children.length > 0) {
        return { ...node, children };
      }

      return null;
    })
    .filter(Boolean);

  return filterRecursive(treeData);
};

export const onClickTitle = (e) => {
  const element = e.target;
  if (element) {
    let parent = element.parentElement;
    parent = parent ? parent.parentElement : null;
    if (parent) {
      const clickableSpan = parent.previousSibling;
      if (clickableSpan) {
        clickableSpan.click();
      }
    }
  }
};

export const renderTitle = (title, bold) => (
    // eslint-disable-next-line
    <span onClick={onClickTitle} className={bold ? 'bold' : ''}>
      {title}
    </span>
);

export const normalizeCRI = (
  _data = [],
  isSelectable = (_item = {}) => (!_item.children?.length),
  excludeLvl3 = false,
  currLvl = 1,
) => _data.map((item) => {
  const clone = { ...item };
  const children = normalizeCRI(!excludeLvl3
      || currLvl !== 2 ? clone.children : [], isSelectable, excludeLvl3, currLvl + 1);
  if (!children.length) {
    delete clone.children;
    return ({
      id: clone.id,
      key: clone.id,
      title: renderTitle(`${clone.clave} - ${clone.denominacion}`),
      value: clone.clave,
      selectable: isSelectable(clone),
    });
  }
  return ({
    id: clone.id,
    key: clone.id,
    children,
    title: renderTitle(`${clone.clave} - ${clone.denominacion}`),
    value: clone.clave,
    selectable: isSelectable(clone),
  });
});

export const formatDataTreeFuentesFinanciamiento = (
  _data = [],
  excludeLvl3 = false,
  currLvl = 1,
) => (
  _data.map((item) => {
    const clone = { ...item };

    const children = formatDataTreeFuentesFinanciamiento(
      !excludeLvl3 || currLvl !== 2 ? clone.children || [] : [],
      excludeLvl3,
      currLvl + 1,
    );

    const node = {
      ...clone,
      key: clone.key || clone.id?.toString(),
      value: clone.value || clone.id?.toString(),
      title: clone.title,
      disabled: !clone.clave_padre_id,
      children, // mantener siempre
    };

    return node;
  }));
export const normalizeFuentesFinanciamiento = (_data = [], level = 0, visited = new Set()) => (
  _data.map((item) => {
    const clone = { ...item };
    const uniqueId = clone.id ?? clone.clave;

    if (visited.has(uniqueId)) {
      return null;
    }

    visited.add(uniqueId);

    const children = Array.isArray(clone.children)
      ? normalizeFuentesFinanciamiento(clone.children, level + 1, new Set(visited))
      : [];

    return {
      ...clone,
      key: clone.id,
      value: clone.id,
      title: renderTitle(`${clone.clave} - ${clone.nombre}`, children.length > 0),
      disabled: item.seleccionable === false,
      children: children.length ? children : undefined,
    };
  }).filter(Boolean));
